import styled from 'styled-components';
import { env } from '@pass-frontend/features/configuration/util';
import { RdsButton } from '@pass-frontend/rally-energon-react';

export enum LoginType {
  MSID = 'MSID',
  HSID = 'HSID',
  OHID = 'OHID',
}

export interface SignInBoxProps {
  title: string;
  buttonText: string;
  loginType: LoginType;
  buttonLink?: string;
}
const SignInBoxStyle = styled.div`
  width: 300px;
  height: 200px;
  radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const SignInButtonTextStyle = styled(RdsButton)`
  width: 100%;
  display: flex;
`;

export function SignInBox(props: SignInBoxProps) {
  const {
    ADMIN_PORTAL_URL,
    OHID_PARTNER_BASE_URL,
    OHID_PARTNER_CLIENT_ID,
    OHID_PARTNER_CALLBACK_REDIRECT_URI,
  } = env();

  const handleClick = () => {
    if (props.loginType === LoginType.OHID) {
      // Handle OHID login with OHID specific endpoint
      const ohidLoginUrl = `${OHID_PARTNER_BASE_URL}/oidc/authorize?client_id=${OHID_PARTNER_CLIENT_ID}&response_type=code&scope=openid+profile+email+address+phone&redirect_uri=${OHID_PARTNER_CALLBACK_REDIRECT_URI}`;
      window.location.replace(ohidLoginUrl);
    } else {
      // Handle MSID and HSID login via admin portal
      const adminPortalUrl =
        'https://' + ADMIN_PORTAL_URL + '?loginType=' + props.loginType;
      window.location.replace(adminPortalUrl);
    }
  };

  return (
    <SignInBoxStyle className="has-rds-bg-white has-rds-p-24 has-rds-radius-8 has-rds-box-shadow-neutral-spread-6">
      <p className="is-rds-h6 has-text-centered">{props.title}</p>
      <div>
        <SignInButtonTextStyle
          className="rds-primary-button rds-link-back is-paddingless"
          onClick={() => handleClick()}
        >
          {props.buttonText}
        </SignInButtonTextStyle>
      </div>
    </SignInBoxStyle>
  );
}
